import {stringIsNullableOrWhiteSpace, validateIsEmail} from '@wix/devzai-utils-common';

/**
 * Factory for the claim form's email-format validator. Exported separately from
 * the React component so the validator can be unit-tested without dragging in
 * React, Stylable, and locale plumbing.
 *
 * The validator skips blank input — the required-field validator owns the
 * empty-value error so we don't surface both messages at once. Mirrors the
 * pattern in `doppe-viewer-auto-form-field-type-resolve-validators.ts`.
 */
export function doppeViewerClaimDownloadFormCreateEmailFormatValidator(
    invalidEmailErrorMessage: string,
): (value: string) => string | undefined {
    return (value) => {
        if (stringIsNullableOrWhiteSpace(value)) {
            return undefined;
        }
        return validateIsEmail(value) ? undefined : invalidEmailErrorMessage;
    };
}
